"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    menuRoot: {
      border: "1px solid ".concat(palette.primary.main),
      borderRadius: 5,
      marginTop: spacing(1 / 2),
      marginBottom: spacing(1 / 2),
      '& > li': {
        color: palette.primary.main,
        fontWeight: 400,
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      },
      '& > li.Mui-disabled': {
        pointerEvents: 'auto'
      }
    }
  };
});

// eslint-disable-next-line @typescript-eslint/ban-types
var ActionsMenu = function ActionsMenu(_ref2) {
  var _ref2$menuId = _ref2.menuId,
      menuId = _ref2$menuId === void 0 ? 'menu-list-grow-id' : _ref2$menuId,
      _ref2$ActionButtonPro = _ref2.ActionButtonProps,
      ActionButtonProps = _ref2$ActionButtonPro === void 0 ? {} : _ref2$ActionButtonPro,
      _ref2$MenuProps = _ref2.MenuProps,
      MenuProps = _ref2$MenuProps === void 0 ? {} : _ref2$MenuProps,
      _ref2$MenuPopperProps = _ref2.MenuPopperProps,
      MenuPopperProps = _ref2$MenuPopperProps === void 0 ? {} : _ref2$MenuPopperProps,
      menuItems = _ref2.menuItems,
      menuData = _ref2.menuData;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorRef = (0, _react.useRef)(null);
  var className = MenuPopperProps.className,
      restPopperProps = (0, _objectWithoutProperties2["default"])(MenuPopperProps, ["className"]);
  var handleToggle = (0, _react.useCallback)(function () {
    setOpen(function (prevOpen) {
      return !prevOpen;
    });
  }, []);
  var handleClose = (0, _react.useCallback)(function (event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }, [setOpen]);
  var handleListKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }, []);
  var handleClickItem = (0, _react.useCallback)(function (data, action) {
    setOpen(false);
    action(data);
  }, []);
  /**
   * Return focus to the button when we transitioned from !open -> open.
   */

  var prevOpen = (0, _react.useRef)(open);

  _react["default"].useEffect(function () {
    if (prevOpen.current && !open && anchorRef.current) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Button, (0, _extends2["default"])({
    ref: anchorRef,
    "aria-controls": open ? menuId : undefined,
    "aria-haspopup": "true",
    onClick: handleToggle,
    variant: "outlined",
    size: "small"
  }, ActionButtonProps), "Actions"), /*#__PURE__*/_react["default"].createElement(_material.Popper, (0, _extends2["default"])({
    className: className,
    open: open,
    anchorEl: anchorRef.current,
    role: undefined,
    transition: true,
    placement: "bottom-start"
  }, restPopperProps), function (_ref3) {
    var TransitionProps = _ref3.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(_material.Grow, TransitionProps, /*#__PURE__*/_react["default"].createElement(_material.Paper, null, /*#__PURE__*/_react["default"].createElement(_material.ClickAwayListener, {
      onClickAway: handleClose
    }, /*#__PURE__*/_react["default"].createElement(_material.MenuList, (0, _extends2["default"])({
      id: menuId,
      classes: {
        root: classes.menuRoot
      },
      autoFocusItem: open,
      onKeyDown: handleListKeyDown
    }, MenuProps), menuItems.filter(function (_ref4) {
      var hidden = _ref4.hidden;
      return !hidden;
    }).map(function (_ref5) {
      var id = _ref5.id,
          text = _ref5.text,
          disabled = _ref5.disabled,
          action = _ref5.action,
          tooltip = _ref5.tooltip,
          dataTestid = _ref5.dataTestid;
      return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
        disabled: disabled,
        key: id,
        onClick: function onClick() {
          return !disabled && handleClickItem(menuData, action);
        },
        "data-testid": dataTestid
      }, tooltip ? /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: tooltip,
        placement: "top"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        width: 1
      }, text)) : text);
    })))));
  }));
};

var _default = ActionsMenu;
exports["default"] = _default;